import React from "react";
import { createRoot } from "react-dom/client";

import { Widget } from "@components/Widget/Widget";
import { WidgetOptions } from "./types";
import "./styles/variables.css";

declare global {
  interface Window {
    ReviewsWidgetLib: typeof ReviewsWidgetLib;
  }
}

function mount(elementId: string | Element, options: WidgetOptions) {
  console.log("Mount function called with:", elementId, options);

  const container =
    typeof elementId === "string"
      ? document.querySelector(elementId)
      : elementId;

  if (!container) {
    console.error("Container not found:", elementId);
    return;
  }

  try {
    const root = createRoot(container);

    root.render(
      React.createElement(
        React.StrictMode,
        null,
        React.createElement(Widget, {
          productArticle: options.productArticle,
          baseColor: options.baseColor,
          productName: options.productName,
          clientId: options.clientId,
        })
      )
    );

    console.log("Widget mounted successfully");
  } catch (error) {
    const err = error as Error;

    console.error("Error rendering widget:", err);
    container.innerHTML = `
      <div style="padding: 20px; border-radius: 8px; background-color: #fee2e2; color: #b91c1c;">
        <h3 style="margin-top: 0;">Error</h3>
        <p>${err.message}</p>
      </div>
    `;
  }
}

const ReviewsWidgetLib = {
  mount: mount,
  Widget: Widget,
};

if (typeof window !== "undefined") {
  window.ReviewsWidgetLib = ReviewsWidgetLib;
}

export default ReviewsWidgetLib;

export { mount, Widget };
